// @ts-nocheck
import React from 'react';
import EventManagementOfficials from '@/pages/admin/event-management/EventManagementOfficials';

const DemoOfficials: React.FC = () => {
  return <EventManagementOfficials />;
};

export default DemoOfficials;
